import { PureComponent } from 'react';

import { MessageStatus } from '../messageStatus';

type PropsT = {};

export default class StatusAbandoned extends PureComponent<PropsT> {
  render() {
    const { ...otherProps } = this.props;

    return (
      <MessageStatus
        {...(otherProps as any)}
        text="Conversation was abandoned by customer"
      />
    );
  }
}
